export default __webpack_public_path__ + "static/articles-hepato-silimarin-62713abdff9ec5fd01fb80d2f614ce5a.jpg";